<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bc11"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('driverTeamManage_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('driverTeamManage_add_button') && isTopBranch"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('driverTeamManage_import_button') && isTopBranch"
          @click="funcImport()"
        >
          导入
        </el-button>
        <el-button
          v-if="
            getLimit('driverTeamManage_checkQuire_button') &&
              isAdmin &&
              isTopBranch
          "
          @click="funcheckQuire"
        >
          设置必填项
        </el-button>
        <el-button
          v-if="getLimit('driverTeamManage_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      :cell-class-name="cellClassName"
      class="mytable-style"
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'authStatus')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          min-width="280"
          title="审核时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="linkMan"
          title="车队名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.linkMan"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="联系人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          min-width="280"
          title="身份证到期日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange1"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isShare"
          title="是否清分"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isShare')
          "
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isShare" placeholder="请选择" clearable>
            <el-option
              v-for="item in isShareOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shareRatio"
          title="清分比率(%)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shareRatio"
            placeholder="请输入清分比率(%)"
            clearable
            @input="
              value =>
                formFormatter.ishundredInteger(
                  value,
                  oldValue,
                  listQuery,
                  'shareRatio'
                )
            "
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="legalPerson"
          title="法人代表名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.legalPerson"
            placeholder="请输入法人代表名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="businessLicenseNumber"
          title="统一信用代码"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.businessLicenseNumber"
            placeholder="请输入统一信用代码"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="roadPermitNumber"
          title="道路运输经营许可证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roadPermitNumber"
            placeholder="请输入道路运输经营许可证号"
            clearable
          />
        </template>
      </vxe-table-column>

      <!-- 清分 -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          min-width="280"
          title="注册时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange2"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="320" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('driverTeamManage_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row)">
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverTeamManage_edit_button') && isTopBranch"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverTeamManage_delete_button') && isTopBranch"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.partyCode)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('driverTeamManage_importdirver_button') && isTopBranch
            "
            class="item"
            effect="dark"
            content="导入车队实际承运人"
            placement="top"
          >
            <vxe-button type="text" @click="funcImportDriver(scope.row)">
              <em class="el-icon-upload2" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('driverTeamManage_ApplyDis_button') &&
                showApplyDisBtn(scope.row)
            "
            class="item"
            effect="dark"
            content="申请DIS"
            placement="top"
          >
            <vxe-button type="text" @click="funcApply(scope.row.partyCode)">
              <em class="el-icon-connection" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelTeamImportFlag"
      title="导入"
      width="1300"
      height="800"
      resize
    >
      <teamImport ref="teamImportRef" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-modal
      v-model="modelTeamDriverImportFlag"
      title="导入车队实际承运人"
      width="1300"
      height="800"
      resize
    >
      <teamDriverImport ref="teamDriverImportRef" @hideModel="hideModel2" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getDriverTeamList, delDriverTeam } from "@/api/driver";
import { maYiBlockChain } from "@/api/shipment";
import teamImport from "./teamImport.vue";
import teamDriverImport from "./components/teamDirver/teamDriverImport";
export default {
  name: "DriverTeamManage",
  components: {
    teamImport,
    teamDriverImport
  },
  inject: ["reload"],
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportTeam", //导出接口
        name: "车队管理"
      },
      exportableQuantity: localStorage.getItem("exportableQuantity"),
      exportableUrl: "ntocc-basic-api/driver/exportTeam",
      loading: false,
      tableData: [],
      modelTeamImportFlag: false,
      modelTeamDriverImportFlag: false,
      listQuery: {
        gmtCreatedRange: "",
        gmtCreatedRange1: "",
        gmtCreatedRange2: "",
        driverType: 1,
        authStatus: "",
        authStatusExt: "",
        linkMan: "",
        phone: "",
        identificationNumber: "",
        balanceStart: "",
        balanceEnd: "",
        gmtCreatedEnd: "",
        gmtCreatedStart: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        branchCodeExt: this.$store.state.user.party.branchCode
      },
      sumObject: {
        balance: 0
      },
      // 审核状态
      authStatusOptions: [
        { label: "未审核", value: 0, color: "gray" },
        // { label: "审核中", value: 1, color: "#0000ff" },
        { label: "审核未通过", value: 2, color: "#ff0000" },
        { label: "审核通过", value: 3, color: "#00bd93" }
      ],
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否顶级机构，只有顶级机构可以对车队增删改
      isTopBranch: false,
      // 是否admin
      isAdmin: false
    };
  },
  watch: {
    "$store.state.tagsView.cachedViews": function(cachedViews) {
      if (!cachedViews.includes("DriverTeamManage")) {
        let route = this.getRoute(this.$router.options.routes);
        route.meta.keepLive = false;
      }
    },
    "$route.query.needRefreshDriverCompany": function(newVal, oldVal) {
      // 新增调回需要刷新数据
      if (newVal) {
        this.$nextTick(() => {
          this.RefreshList();
          let newQuery = JSON.parse(JSON.stringify(this.$route.query));
          delete newQuery.needRefreshDriverCompany;
          this.$router.replace({ query: newQuery });
        });
      }
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.findList();
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.platformDid = dataBranch.platformDid;
    if (
      dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiBlockChain
    ) {
      this.openMaYiBlockChain =
        dataBranch.partyGroupConfigCacheMap
          .MaYiBlockChainConfig_useMaYiBlockChain.configValue == 1;
    }
    this.isTopBranch = dataBranch.level == 0;
  },
  methods: {
    getRoute(routerList) {
      var list = "";
      for (let item of routerList) {
        if (item.children) {
          let clist = this.getRoute(item.children);
          if (this.getRoute(item.children)) {
            return clist;
          }
        }
        if (item.name == "DriverTeamManage") {
          list = item;
          return list;
        }
      }
      return list;
    },
    showApplyDisBtn(row) {
      if (!this.openMaYiBlockChain) {
        return false;
      }
      let hasDid = !(
        typeof this.platformDid == "undefined" || this.platformDid == ""
      );
      return (
        this.isTopBranch &&
        hasDid &&
        row.authStatusExt == 3 &&
        (row.szwlDid == null || row.szwlDid == "")
      );
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getDriverTeamList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 设置必填项
    funcheckQuire(row) {
      this.$router.push({
        path: "/basicInfo/driver/requiredDriverTeamForm",
        query: { checkQuire: true }
      });
    },
    // 隐藏弹框
    hideModel() {
      this.modelTeamImportFlag = false;
      this.findList();
    },
    // 隐藏弹框
    hideModel2() {
      this.modelTeamDriverImportFlag = false;
      this.findList();
    },
    // 导入
    funcImport() {
      this.$refs[`teamImportRef`].init();
      this[`modelTeamImportFlag`] = true;
    },
    // 导入
    funcImportDriver(row) {
      if (row) {
        this.$refs[`teamDriverImportRef`].getInfo(row.partyCode);
      }
      this[`modelTeamDriverImportFlag`] = true;
    },
    // 文件整合

    // 添加
    funcAdd() {
      this.$router.push({
        path: "/basicInfo/driver/addDriverTeamForm"
      });
    },
    //详情
    funcDetail(row) {
      this.$router.push({
        path: "/basicInfo/driver/infoDriverTeamForm",
        query: { code: row.code, partyCode: row.partyCode }
      });
    },
    // 编辑
    funcEdit(row) {
      this.$router.push({
        path: "/basicInfo/driver/editDriverTeamForm",
        query: { code: row.code, partyCode: row.partyCode }
      });
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delDriverTeam({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 申请DIS
    async funcApply(codes) {
      let response = await maYiBlockChain(codes);
      this.$message({ message: response.msg, type: "success" });
      this.findList();
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    //提示标红
    cellClassName({ row, rowIndex, column, columnIndex }) {
      const overDueType = row.overDueType || [];

      //身份证
      if (column.property === "idCardDueDate") {
        if (overDueType.indexOf("idCard") > -1) {
          return "col-red";
        }
      }
      // //驾驶证
      // if (column.property === "driverLicenseDueDate") {
      //   if (overDueType.indexOf('driver')>-1) {
      //     return "col-red";
      //   }
      // }
      // //形驶证
      // if (column.property === "vehicleLicenseDueDate") {
      //   if (overDueType.indexOf('vehicle')>-1) {
      //     return "col-red";
      //   }
      // }
      // //从业资格证
      // if (column.property === "workLicenseDueDate") {
      //   if (overDueType.indexOf('work')>-1) {
      //     return "col-red";
      //   }
      // }
      // //从业资格证
      // if (column.property === "roadTransportCertificateDate") {
      //   if (overDueType.indexOf('road')>-1) {
      //     return "col-red";
      //   }
      // }
    }
    // 设置底部合计
    // footerMethod({ columns, data }) {
    //   return [
    //     columns.map((column, columnIndex) => {
    //       if (columnIndex === 0) {
    //         return "合计";
    //       }
    //       if (column.property === "balance") {
    //         // 余额
    //         return this.sumObject.balance;
    //       }
    //       if (["pageviews", "forecast"].includes(column.property)) {
    //         return  this.$XEUtils.sum(data, column.property);
    //       }
    //       return null;
    //     })
    //   ];
    // }
  }
};
</script>
<style>
.mytable-style .vxe-body--column.col-red {
  background-color: red;
  color: #fff;
}
</style>
